import { useLocation } from "react-router";
import makeQueryFromLocation from "theme/modules/Layer/makeQueryFromLocation";
import { useMemo } from "react";

const useLayerPagination = (layer) => {
  const location = useLocation();
  const query = useMemo(() => makeQueryFromLocation(location, {}), [location]);

  const page = query.getCurrentPage();
  const pageSize = query.getSize();
  return [page, Math.ceil(layer.total / pageSize), location];
};

export default useLayerPagination;
